import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../Common';
import Notifications from '../../Models/Notifications';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import { SideBar } from '../Common/SideBar';
import { AffiliatorSidebar } from '../Common/AffiliatorSidebar';

class FollowingNotification extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allNotifications: [],
            id: this.props.location.state.id
        }
        console.log(this.props.location.state.id)
        this.getRecruitmentExpiredNotification(this.props.location.state.id)
        this.getFollowingNotification(this.props.location.state.id)
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    getRecruitmentExpiredNotification(id) {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (this.props.location.state.type === 'RECRUITMENTCLOSED') {
                Notifications.getRecruitmentExpiredNotification(x.id, id).then(res => {
                    if (res.data.payload !== null) {
                        this.setState({ allNotifications: res.data.payload })
                    }
                })
            }
        }
    }
    getFollowingNotification(id) {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (this.props.location.state.type === 'FOLLOW') {
                Notifications.getFollowingNotification(x.id, id).then(res => {
                    if (res.data.payload !== null) {
                        this.setState({ allNotifications: res.data.payload })
                    }
                })
            }
        }
    }

    serviceServe() {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <div className="text-center mt-2">
                        <Link to={{
                            pathname: `/buyer-transaction`
                        }} className="">
                            <button className="btn btn-success">{this.props.t('0')}</button>
                        </Link>
                    </div>
                )
            } else if (x.user_type_id === 2) {
                return (
                    <div className="text-center mt-2">
                        <Link to={{
                            pathname: `/seller-buyer-transaction`
                        }} className="">
                            <button className="btn btn-success">{this.props.t('0')}</button>
                        </Link>
                    </div>
                )
            } else if (x.user_type_id === 3) {
                return (
                    <div className="text-center mt-2">
                        <Link to={{
                            pathname: `/affiliator-buyer-transaction`
                        }} className="">
                            <button className="btn btn-success">{this.props.t('0')}</button>
                        </Link>
                    </div>
                )
            }
        }
    }

    serviceAccept() {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <div className="text-center mt-2">
                        <Link to={{
                            pathname: `/buyer-transaction`
                        }} className="">
                            <button className="btn btn-success">{this.props.t('0')}</button>
                        </Link>
                    </div>
                )
            } else if (x.user_type_id === 2) {
                return (
                    <div className="text-center mt-2">
                        <Link to={{
                            pathname: `/seller-buyer-transaction`
                        }} className="">
                            <button className="btn btn-success">{this.props.t('0')}</button>
                        </Link>
                    </div>
                )
            } else if (x.user_type_id === 3) {
                return (
                    <div className="text-center mt-2">
                        <Link to={{
                            pathname: `/affiliator-buyer-transaction`
                        }} className="">
                            <button className="btn btn-success">{this.props.t('0')}</button>
                        </Link>
                    </div>
                )
            }
        }
    }

    redirectStatus(type) {
        if (type === 'REQUESTDECLINED') {
            return (
                <div className=""></div>
            )
        } else if (type === 'SERVICERECEIVED') {
            return (
                <div className="text-center mt-2">
                    <Link to={{
                        pathname: `seller-complete-cancel`
                    }} className="">
                        <button className="btn btn-success">{this.props.t('0')}</button>
                    </Link>
                </div>
            )
        } else if (type === 'RESPONSEACCEPTED') {
            return (
                <div >
                    {this.serviceAccept()}
                </div>
            )
        } else if (type === 'REQUESTRECEIVED') {
            return (
                <div className="text-center mt-2">
                    <Link to={{
                        pathname: `seller-estimation`,
                    }} className="">
                        <button className="btn btn-success">{this.props.t('0')}</button>
                    </Link>
                </div>
            )
        } else if (type === 'SERVED') {
            return (
                <div >
                    {this.serviceServe()}
                </div>
            )
        } else if (type === 'RECRUITMENTCLOSED') {
            return (
                <div className=""></div>
            )
        } else if (type === 'FOLLOW') {
            return (
                <div className="text-center mt-2">
                    <Link to={{
                        pathname: `/followers`,
                    }} className="">
                        <button className="btn btn-success">{this.props.t('0')}</button>
                    </Link>
                </div>
            )
        }
    }

    showSidebar() {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.user_type_id === 1) {
                return (
                    <BuyerSidebar />
                )
            } else if (x.user_type_id === 2) {
                return (
                    <SideBar />
                )
            } else if (x.user_type_id === 3) {
                return (
                    <AffiliatorSidebar />
                )
            }
        }
    }

    render() {
        return (
            <div className="">
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4 input_name">
                                    {this.showSidebar()}
                                </div>
                                <div className="col-md-8 ">
                                    <div className="">
                                        {this.props.t('9')}
                                    </div>
                                    <hr />
                                    {/* {this.notificationFollow()} */}
                                    <div className="top_back">
                                        {this.state.allNotifications.notification_text}
                                    </div>
                                    {this.redirectStatus(this.state.allNotifications.notification_type)}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export { FollowingNotification }

 FollowingNotification = withTranslation('src_Components_Notification_FollowingNotification')(FollowingNotification);